import React from 'react';
import classNames from './style.module.scss';

interface ElevationProps {
	children: React.ReactNode | React.ReactNode[];
	isElevated: boolean;
}

const Elevation: React.FC<ElevationProps> = ({ children, isElevated }) => {
	return isElevated ? (
		<div className={classNames.instructionElevation}>{children}</div>
	) : (
		<div>{children}</div>
	);
};

export default Elevation;
